//JSPDF - Jacascript PDF creator library
//NPM - https://www.npmjs.com/package/jspdf
//Library Examples Site: http://raw.githack.com/MrRio/jsPDF/master/index.html

//Imports
import {jsPDF} from "jspdf";

export default {
    name: "PDFUtils",
    pageNumber: 1,
    startY: 1.75,
    startX: 0.5,
    contentLineHeight: 0.20,
    sectionHeaderLineHeight: 0.5,
    margin: 0.5,
    pageWidth: 8.5,

    createProjectCoverSheet(facilityProject, primaryFacility, relatedEntities) {
        let startY = this.startY
        let startX = this.startX

        const doc = new jsPDF('p', 'in', 'letter');//Landscape, inches, letter size
        this.setHeader(doc, "PROJECT REPORT");
        this.setFooter(doc);

        //Page Header
        startY += this.setSectionHeader(doc, startX, startY, "Project");
        startY += this.setSectionContent(doc, startX, startY, "", facilityProject.projectNo, false, true)
        startY += this.setSectionContent(doc, startX, startY, "", facilityProject.name, false, true)
        startY += this.contentLineHeight

        //Project details Section
        //startY += this.setSectionContent(doc, startX, startY, "Project Number:", facilityProject.projectNo)
        startY += this.setSectionContent(doc, startX, startY, "Record ID:", facilityProject.projectId.toString())
        //startY += this.setSectionContent(doc, startX, startY, "Project Name:", facilityProject.name)

        //Project year/source Section
        startY += this.setSectionContent(doc, startX, startY, "Project Year:", facilityProject.year.toString())
        startY += this.setSectionContent(doc, startX, startY, "Project Source:", facilityProject.source)

        //Related projects Section
        startY += this.setSectionHeader(doc, startX, startY, "Related Projects");
        startY += this.setSectionContent(doc, startX, startY, "", facilityProject.relatedProjects, false)

        //Facilities Section
        startY += this.setSectionHeader(doc, startX, startY, "Primary Building");
        startY += this.setSectionContent(doc, startX, startY, "", `${primaryFacility.building} ${primaryFacility.name}`, false)

        //Related Entities Section
        startY += this.setSectionHeader(doc, startX, startY, "Related Buildings");
        this.addRelatedEntities(doc, relatedEntities, startX, startY)

        //Save
        window.open(doc.output('bloburl', {filename: `${facilityProject.projectNo}.pdf`}))
    },

    addRelatedEntities(doc, relatedEntities, startX, startY) {
        let availableHeight = 10.5 - this.margin - startY
        let workingHeight = availableHeight
        let columnOffset = 0

        relatedEntities.forEach((entity, index, entities) => {
            if (workingHeight <= 0) {
                workingHeight = availableHeight
                columnOffset = 4.5
                startY -= workingHeight
            }
            this.setSectionContent(doc, startX + columnOffset, startY, '', `${entity.building} ${entity.name}`, false)

            workingHeight -= this.contentLineHeight
            startY += this.contentLineHeight

            if (index < entities.length && columnOffset === 4.5 && workingHeight <= 0) {
                doc.addPage('letter', 'p')
                this.pageNumber++
                this.setFooter(doc)
                startY = 0.5
                columnOffset = 0
                workingHeight = availableHeight = 9
                startY += this.setSectionHeader(doc, startX, startY, "Related Buildings");
            }

        }, this)
    },

    setHeader(doc, title) {
        //HEADER BOX
        doc.setDrawColor(24, 69, 59);
        doc.setFillColor(4, 69, 59);
        doc.rect(0.5, 0.5, 7.5, 1.0, "F");
        doc.setDrawColor(123, 189, 0);
        doc.setLineWidth(0.05);
        doc.line(0.5, 1.5, 8, 1.5);
        //HEADER TEXT
        doc.setFont("helvetica", "normal");
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(12);
        doc.text("INFRASTRUCTURE PLANNING AND FACILITIES", 0.75, 0.75, {maxWidth: 7, align: "left"});
        doc.setFont("helvetica", "bold");
        doc.setFontSize(20);
        doc.text(title, 0.75, 1.15, {maxWidth: 7, align: "left"});
    },

    setSectionHeader(doc, x, y, sectionTitle) {
        doc.setTextColor("black");
        doc.setFont("helvetica", "bold");
        doc.setFontSize(11);
        y += this.contentLineHeight
        doc.text(sectionTitle, x, y, {maxWidth: 7, align: "left"});
        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.01);
        y += 0.15;
        doc.line(x, y, 8, y);

        return 0.70
    },

    setSectionContent(doc, x, y, label, value, offsetContent = true, boldValue = false) {
        let usedHeight = this.contentLineHeight
        let twoColumnLineWidth = this.pageWidth - this.margin * 4

        if (label && label.length > 0) {
            doc.setTextColor("black");
            doc.setFont("helvetica", "bold");
            doc.setFontSize(10);
            doc.text(label, x + 1.25, y, {maxWidth: 7, align: "right"});
        }

        if (offsetContent) x += 1.35
        doc.setFontSize(8);

        doc.setFont("helvetica", boldValue ? "bold" : "normal");
        if (!value) {
            doc.text("N/A", x, y, {maxWidth: twoColumnLineWidth, align: "left"});
        } else {
            let lines = doc.splitTextToSize(value, twoColumnLineWidth);
            if (lines.length > 1) {
                doc.text(value, x, y, {maxWidth: twoColumnLineWidth, align: "left"});
                usedHeight += lines.length * 0.1
            } else {
                doc.text(value, x, y, {maxWidth: twoColumnLineWidth, align: "left"});
            }
        }

        return usedHeight
    },
    setFooter(doc) {
        doc.setDrawColor(123, 189, 0);
        doc.setLineWidth(0.05);
        doc.line(0.5, 10.25, 8, 10.25);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);
        doc.text("MICHIGAN STATE UNIVERSITY", 0.5, 10.5, {maxWidth: 4, align: "left"});
        doc.text(new Date().toLocaleDateString("en-US") + " Page " + this.pageNumber, 8, 10.5, {
            maxWidth: 4,
            align: "right"
        });
    }
}
